import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { hasOpenDialogs } from '../../../../../core/functions/dialog-helper';
import { ReadOnlyWarningType } from '../../constants/read-only-warning-type-enum';
import {
    READ_ONLY_WARNING_MESSAGES,
    READ_ONLY_WARNING_MODAL_CANCEL_TITLE,
    READ_ONLY_WARNING_MODAL_TITLE,
} from './constants/read-only-warning-modal.constants';

@Injectable({ providedIn: 'root' })
export class ReadOnlyWarningModalService {
    constructor(private readonly dialog: MatDialog) {}

    /**
     * Shows a read-only warning modal for entities that cannot be edited by a customer.
     * The specific message displayed depends on the provided ReadOnlyWarningType.
     */
    showIfNotAlreadyOpen(type: ReadOnlyWarningType): void {
        if (hasOpenDialogs(this.dialog)) {
            return;
        }

        const content = READ_ONLY_WARNING_MESSAGES[type];

        this.dialog.open(ModalComponent, {
            data: {
                title: READ_ONLY_WARNING_MODAL_TITLE,
                content,
                cancelTitle: READ_ONLY_WARNING_MODAL_CANCEL_TITLE,
            },
            disableClose: false,
        });
    }
}
